import { useUser } from "$global-providers/user-provider";
import useFacility from "$routes/_lib/use-facility";
import { styled, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const Container = styled("div")(({ theme }) => ({
  color: theme.palette.common.white,
  textAlign: "end",
}));

const FacilityNameOrSkeleton: FC = () => {
  const { data: facilityData, loading } = useFacility();
  const facilityName = facilityData?.name;

  return (
    <Typography variant="body2">
      {facilityName ? (
        facilityName
      ) : loading ? (
        <Skeleton variant="text" width={140} />
      ) : (
        "Unknown facility"
      )}
    </Typography>
  );
};

export const UserDetails = () => {
  const { firstName, lastName } = useUser();

  return (
    <Container>
      <FacilityNameOrSkeleton />
      {firstName && lastName && (
        <Typography variant="h5">{`${firstName} ${lastName}`}</Typography>
      )}
    </Container>
  );
};
